module.exports = __webpack_public_path__ + "static/media/14UNEP25.a8f1af19.jpg";